import { EntityList } from '@/common/entityFramework/entityList/EntityList';
import { ObjUtils } from '@/common/utils/ObjUtils';
import { useCallback } from 'react';

export const CustEligProgList = ({ custId }) => {
  const augRowsReq = useCallback(
    (rowsReq) => {
      rowsReq.query = 'CUST_ELIG_PROGS';
      rowsReq.replaceParams = { custId };
    },
    [custId],
  );
  const augTabButtons = useCallback((tabButtons) => ObjUtils.clearObj(tabButtons), []);

  return <EntityList entity="PROG" augRowsReq={augRowsReq} augTabButtons={augTabButtons} />;
};
